/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { injectReducer, RootState } from 'store/store'

export enum BulkActionStatus {
    IDLE = 1,
    ACTIVE = 2,
    DONE = 3,
}

export enum SelectionSliceKeys {
    TASKS = 'SelectedTasks',
    ENTITLEMENTS = 'SelectedEntitlements',
}

export interface SelectionsState<T> {
    selections: T[]
    bulkActionStatus: BulkActionStatus
    activeBulkActionId: string
}

const createSelectionsSlice = <T>(name: string) => {
    const initialState: SelectionsState<T> = {
        selections: [] as T[],
        bulkActionStatus: BulkActionStatus.IDLE,
        activeBulkActionId: '',
    }

    const slice = createSlice({
        name,
        initialState,
        reducers: {
            setSelections: (state, action: PayloadAction<T[]>) => {
                state.selections = action.payload as Draft<T>[]
            },
            setBulkActionStatus: (state, action: PayloadAction<BulkActionStatus>) => {
                state.bulkActionStatus = action.payload
            },
            clearSelections: (state) => {
                state.selections = []
            },
            setActiveBulkActionId: (state, action: PayloadAction<string>) => {
                state.activeBulkActionId = action.payload
            },
        },
    })

    return slice
}

export const useSelections = <T>(name: string) => {
    const slice = createSelectionsSlice<T>(name)
    injectReducer(name, slice.reducer)
    return slice
}

export const useSelectionsState = <T>(name: string) => {
    const selections = useSelector((state: RootState) => state[name]) as SelectionsState<T>

    return selections || {
        selections: [] as T[],
        bulkActionStatus: BulkActionStatus.IDLE,
        activeBulkActionId: '',
    }
}
